<template>
	<svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
		<rect x="7.75" y="7.75" width="28.5" height="28.5" rx="14.25" fill="#E5F6FD" stroke="#0074B5" stroke-width="1.5"/>
		<circle cx="15.8359" cy="15.5625" r="1.25" fill="#E5F6FD" stroke="#0074B5" stroke-width="1.5"/>
		<circle cx="15.8359" cy="28.4375" r="1.25" fill="#E5F6FD" stroke="#0074B5" stroke-width="1.5"/>
		<circle cx="28.1641" cy="15.5625" r="1.25" fill="#E5F6FD" stroke="#0074B5" stroke-width="1.5"/>
		<circle cx="28.1641" cy="28.4375" r="1.25" fill="#E5F6FD" stroke="#0074B5" stroke-width="1.5"/>
		<circle cx="22" cy="13.5625" r="1.25" fill="#E5F6FD" stroke="#0074B5" stroke-width="1.5"/>
		<circle cx="12.9922" cy="22" r="1.25" fill="#E5F6FD" stroke="#0074B5" stroke-width="1.5"/>
		<circle cx="31.459" cy="22" r="1.25" fill="#E5F6FD" stroke="#0074B5" stroke-width="1.5"/>
		<circle cx="22" cy="30.7695" r="1.25" fill="#E5F6FD" stroke="#0074B5" stroke-width="1.5"/>
	</svg>
</template>
